// extracted by mini-css-extract-plugin
module.exports = {"switch":"_9330de7794--switch--JOY1S","switch__icon":"_9330de7794--switch__icon--SsMEM"};